const routes = [
    {
        path: "/reports/student",
        component: () => import("../pages/student/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentreport_index"
        },
        component_full_path: "reports/pages/student/Index"
    }
];

export default routes;
